import { render, staticRenderFns } from "./CountryCurrencyMapping.vue?vue&type=template&id=37511c64&scoped=true"
import script from "./CountryCurrencyMapping.vue?vue&type=script&lang=js"
export * from "./CountryCurrencyMapping.vue?vue&type=script&lang=js"
import style0 from "./CountryCurrencyMapping.vue?vue&type=style&index=0&id=37511c64&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37511c64",
  null
  
)

export default component.exports